import { IToken } from '@/entities/token';
import { parseJwt } from '@/tools/session';
import { createModule, action, mutation } from 'vuex-class-component';

const VuexModule = createModule({
    namespaced: 'app',
    strict: true
});

export class AppStore extends VuexModule {
    private userRoles: string[] = [];
    private userOid: string = '';

    private readonly createTeamRoles = ['Contributor', 'ClientValidator', 'InternalValidator', 'ExternalValidator'];

    get canCreateNews() {
        return this.userRoles.find(r => this.createTeamRoles.indexOf(r) >= 0);
    }

    get userId() {
        return this.userOid;
    }

    @action
    public async setUserInformation(token: string | undefined) {
        if (token) {
            const userInfo = parseJwt(token);
            this.updateUserInformation(userInfo);
        }
    }

    @mutation
    private updateUserInformation(userInfo: IToken) {
        this.userRoles = userInfo.roles;
        this.userOid = userInfo.oid;
    }
}
